import { useState } from 'react';
import { Paper, Stack, Tabs, Title } from '@mantine/core';
import { DocumentReviewFilterBar } from '../components/DocumentReviewFilterBar.tsx';
import { DocumentReviewTable } from '../components/DocumentReviewTable.tsx';
import {
  REVIEW_TABS,
  getReviewStateOfTab,
  isReviewTabValue,
} from '../constants/reviewTabs.ts';
import { useAccountDocumentList } from '../hooks/useAccountDocumentList.ts';
import { useDocumentReviewFilters } from '../hooks/useDocumentReviewFilters.ts';
import { useFilteredAccountDocuments } from '../hooks/useFilteredAccountDocuments.ts';
import type { DocumentType } from '../model.ts';

const PAGE_SIZE = 12;

const DriverDocumentReviewPage = () => {
  const {
    tab,
    keyword,
    documentType,
    setTab,
    setKeyword,
    setDocumentType,
    resetFilters,
  } = useDocumentReviewFilters();
  const [page, setPage] = useState(1);

  const { data, isLoading } = useAccountDocumentList(getReviewStateOfTab(tab));
  const filteredRecords = useFilteredAccountDocuments(data?.documents ?? [], {
    keyword,
    documentType,
  });

  const handleTabChange = (value: string | null) => {
    if (!isReviewTabValue(value)) return;
    setTab(value);
    setPage(1);
  };

  const handleKeywordChange = (value: string) => {
    setKeyword(value);
    setPage(1);
  };

  const handleDocumentTypeChange = (value: DocumentType | null) => {
    setDocumentType(value);
    setPage(1);
  };

  const handleReset = () => {
    resetFilters();
    setPage(1);
  };

  return (
    <Paper radius="lg" p="xl" shadow="xl">
      <Stack gap="md">
        <Title order={2}>駕駛資料審核</Title>

        <Tabs value={tab} onChange={handleTabChange}>
          <Tabs.List>
            {REVIEW_TABS.map(({ value, label }) => (
              <Tabs.Tab key={value} value={value}>
                {label}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>

        <DocumentReviewFilterBar
          keyword={keyword}
          documentType={documentType}
          onKeywordChange={handleKeywordChange}
          onDocumentTypeChange={handleDocumentTypeChange}
          onReset={handleReset}
        />

        <DocumentReviewTable
          tab={tab}
          records={filteredRecords.slice(
            (page - 1) * PAGE_SIZE,
            page * PAGE_SIZE,
          )}
          totalRecords={filteredRecords.length}
          page={page}
          pageSize={PAGE_SIZE}
          fetching={isLoading}
          onPageChange={setPage}
        />
      </Stack>
    </Paper>
  );
};

export default DriverDocumentReviewPage;
